// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offline-indicator {\n  width: 100%;\n  padding: 10px 0;\n  background-color: #424242;\n  color: white;\n  text-align: center;\n  font-size: 16px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\nhtml.device-iphone-x .offline-indicator {\n  padding-bottom: constant(safe-area-inset-bottom);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
